import * as i0 from '@angular/core';
import { inject, Injectable } from '@angular/core';
import { WINDOW } from '@effy-tech/angular-common/utils';

var GtmEventValue;
(function (GtmEventValue) {
    GtmEventValue["PageView"] = "pageView";
    GtmEventValue["CreateLead"] = "creation-piste";
})(GtmEventValue || (GtmEventValue = {}));
var GtmPropertieName;
(function (GtmPropertieName) {
    GtmPropertieName["event"] = "event";
    GtmPropertieName["GaEventPage"] = "ga-event-page";
    GtmPropertieName["GaEventCategory"] = "ga-event-category";
    GtmPropertieName["GaEventAction"] = "ga-event-action";
    GtmPropertieName["GaEventLabel"] = "ga-event-label";
    GtmPropertieName["GaEventValue"] = "ga-event-value";
})(GtmPropertieName || (GtmPropertieName = {}));

class GoogleTagManagerService {
    constructor() {
        this.window = inject(WINDOW);
    }
    pushEvent(event) {
        if (!this.window.dataLayer) {
            this.window.dataLayer = [];
        }
        this.window.dataLayer.push(event);
    }
    pageView(page) {
        this.pushEvent({
            [GtmPropertieName.event]: GtmEventValue.PageView,
            [GtmPropertieName.GaEventPage]: page,
        });
    }
    pushEventLogin(pageUrl, isSuccess) {
        const eventPage = pageUrl + (isSuccess ? '/succes' : '/echec');
        this.pageView(eventPage);
    }
    pushEventCreateLead(category, works, worksIntentionValue, pisteId) {
        this.pushEvent({
            event: GtmEventValue.CreateLead,
            [GtmPropertieName.GaEventAction]: 'form-validation',
            [GtmPropertieName.GaEventCategory]: category,
            [GtmPropertieName.GaEventLabel]: this.getWorksGTM(works),
            ...(worksIntentionValue && {
                [GtmPropertieName.GaEventValue]: worksIntentionValue,
            }),
            pisteId,
        });
    }
    getWorksGTM(works) {
        return works?.map(work => work).join('|');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.13", ngImport: i0, type: GoogleTagManagerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.13", ngImport: i0, type: GoogleTagManagerService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.13", ngImport: i0, type: GoogleTagManagerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { GoogleTagManagerService, GtmEventValue, GtmPropertieName };
